import { CategoryMegaMenuMasonryColumns } from '@/widgets/Navbar/DesktopMenu/_components/CategoryMegaMenu/_components/CategoryMegaMenuMasonry/_components/CategoryMegaMenuMasonryColumns';

import { distributeCategoryMegaMenuColumns } from '@/utilities/distributeCategoryMegaMenuColumns';

import { CategoryMegaMenuMasonryProps } from './models';

export const CategoryMegaMenuMasonry = ({ subCategories, isDark, onNavigate }: CategoryMegaMenuMasonryProps) => {
    const twoColumnLayout = distributeCategoryMegaMenuColumns(subCategories, 2);
    const threeColumnLayout = distributeCategoryMegaMenuColumns(subCategories, 3);

    return (
        <>
            <CategoryMegaMenuMasonryColumns columns={twoColumnLayout} isDark={isDark} onNavigate={onNavigate} className='flex gap-x-8 lg:hidden' />
            <CategoryMegaMenuMasonryColumns columns={threeColumnLayout} isDark={isDark} onNavigate={onNavigate} className='hidden gap-x-8 lg:flex' />
        </>
    );
};
